import {type RouteRecordRaw} from "vue-router";
import {canAccess, haveOneAccess, permissionList} from "@/utilities/authorization";

const warehouseRoutes: RouteRecordRaw[] = [
  {
    name: 'warehouse-navigation',
    path: '/warehouse/navigation',
    component: () => import('@/views/warehouse/WarehouseNavigation.vue'),
    beforeEnter: () => haveOneAccess([
      permissionList.READ_WAREHOUSE,
      permissionList.CREATE_WAREHOUSE,
      permissionList.TRANSFER_ITEM_WAREHOUSE
    ]) ? true : {name: 'dashboard'}
  },
  {
    name: 'warehouse',
    path: '/warehouse',
    component: () => import('@/views/warehouse/WarehouseIndex.vue'),
    beforeEnter: () => canAccess(permissionList.READ_WAREHOUSE) ? true : {name: 'warehouse-navigation'}
  },
  {
    name: 'warehouse-new',
    path: '/warehouse/new',
    component: () => import('@/views/warehouse/NewWarehouse.vue'),
    beforeEnter: () => canAccess(permissionList.CREATE_WAREHOUSE) ? true : {name: 'warehouse-navigation'}
  },
  {
    name: 'warehouse-detail',
    path: '/warehouse/:id(\\d+)',
    component: () => import('@/views/warehouse/ShowWarehouse.vue'),
    beforeEnter: () => canAccess(permissionList.READ_WAREHOUSE) ? true : {name: 'warehouse-navigation'}
  },
  {
    name: 'warehouse-update',
    path: '/warehouse/update/:id(\\d+)',
    component: () => import('@/views/warehouse/UpdateWarehouse.vue'),
    beforeEnter: () => canAccess(permissionList.UPDATE_WAREHOUSE) ? true : {name: 'warehouse-navigation'}
  },
  {
    name: 'warehouse-transfer',
    path: '/warehouse/transfer',
    component: () => import('@/views/warehouse/transfer-item/TransferItemWarehouse.vue'),
    beforeEnter: () => canAccess(permissionList.TRANSFER_ITEM_WAREHOUSE) ? true : {name: 'warehouse-navigation'}
  },
  {
    name: 'warehouse-restrict',
    path: '/warehouse/restrict/:id(\\d+)',
    component: () => import('@/views/warehouse/restrict/RestrictWarehouse.vue'),
    beforeEnter: () => canAccess(permissionList.SUPER_USER) ? true : {name: 'warehouse-navigation'}
  },
]

export default warehouseRoutes
